module.exports = __webpack_public_path__ + "img/14.94ce20f3.jpg";